import {
  AccessCmp,
  // AccessCmp,
  ErrorQuestionCmp,
  MainContentCmp,
  // ThinkCmp,
} from '@/pages/aigc/pages/Agent/ChatPage/components/SubComp';
import React, { memo } from 'react';
import { ThinkCmp } from './IWikiThinkCmp';
import { IWikiReferenceCmp } from './IWikiReferenceCmp';
// 基于上诉子组件，根据服务端流式返回的分块按顺序加载渲染
export const IWikiSortCompChild = (props: any) => {
  const { answer } = props || {};
  const mapKey = {
    think: <ThinkCmp />,
    // 调整为从正文中插入图表，这个组件先注释，但是数据从biData读取
    // biData: <ChartCmp />,
    text: <MainContentCmp />,
    reference: <IWikiReferenceCmp />,
    error: <ErrorQuestionCmp />,
    sensitiveInfo: <AccessCmp />,
  };
  return (
    <div>
      {answer?.map((item: any, index: number) => {
        const comp = mapKey?.[item.type as keyof typeof mapKey];
        if (!comp) {
          return null;
        }
        // TODO: 样式调整待定
        return (
          <div
            key={index}
            style={{
              padding: '0px 0',
            }}
          >
            {
              <comp.type
                key={index}
                {...{ ...props, ...item, index, isShowReference: false }}
              />
            }
          </div>
        );
      })}
    </div>
  );
};

// 单独缓存 SortCompChild 的组件, 避免对话n-1的数据都重新渲染
export const MemoizedCopilotSortCompChild = memo(
  IWikiSortCompChild,
  // (prevProps, nextProps) =>
  //   // 检查关键属性是否发生变化
  //   // console.log('SingleQAprevProps', prevProps, 'nextProps', nextProps)
  //   // prevProps.messageId === nextProps.messageId && !nextProps.isLastQA,
  //    false
);
